var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('LandingSection'),_c('ProblemSection'),_c('RiskSection'),_c('SolutionSection'),_c('SellingPointSection'),_c('SkillsSection'),_c('ClassSection'),_c('StatisticSection'),_c('ContactUsSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }